<template>
  <div>
    <div class="columns pb-3">
      <div class="column">
        <b-field label="Tipo de servicio">
          <b-input
            placeholder="Tipo servicio"
            type="text"
            name="fullName"
            v-model="service.serviceType.title"
            readonly="readonly"
          />
        </b-field>
      </div>
      <div class="column">
        <b-field label="Tipo de mensual *">
          <b-select placeholder="Tipo mensual" expanded v-model="incomeType">
            <option
              v-for="type in incomeTypeList"
              :value="type"
              :key="type.code"
              :id="type.code"
            >
              {{ type.title }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Fecha inicial">
          <b-datepicker
            name="initialDate"
            v-model="service.initialDate"
            placeholder="Seleccione una fecha..."
            icon="calendar-today"
            :date-formatter="formatDate"
          />
        </b-field>
      </div>
      <div class="column">
        <b-field label="Fecha final">
          <b-datepicker
            name="finalDate"
            v-model="service.finalDate"
            placeholder="Seleccione una fecha..."
            :date-formatter="formatDate"
            icon="calendar-today"
            :min-date="service.initialDate"
          />
        </b-field>
      </div>
      <div class="column">
        <b-field label="Liquidación*">
          <b-select
            placeholder="Liquidación"
            expanded
            v-model="service.liquidation"
          >
            <option
              v-for="liquidation in liquidationList"
              :value="liquidation"
              :key="liquidation.code"
              :id="liquidation.code"
            >
              {{ liquidation.title }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Horario*">
          <b-select
            placeholder="Horario"
            expanded
            v-model="service.schedule"
            name="conceptType"
          >
            <option
              v-for="option in scheduleList"
              :value="option"
              :key="option.code"
              :id="option.code"
            >
              {{ option.title }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Cantidad de cupos*">
          <b-input v-model="quotaValue" type="number" @blur="validateQuota" />
        </b-field>
      </div>
      <div class="column">
        <b-field label="Pagar individual">
          <vs-switch v-model="isIndividual" />
        </b-field>
      </div>
      <!-- CAMPO DE LOTES CON MULTISELECT Y LÓGICA DUAL -->
      <div :key="multiselectKey">
        <div class="column is-3">
          <b-field :label="slotFieldLabel">
            <multiselect
              ref="multiselectComponent"
              v-model="slotSelection"
              :options="slotList"
              :multiple="multiSlotMode"
              :close-on-select="!multiSlotMode"
              :show-no-results="false"
              :clear-on-select="false"
              :preserve-search="true"
              :placeholder="slotPlaceholder"
              label="title"
              track-by="code"
              :searchable="true"
              :loading="false"
              :internal-search="true"
              :hide-selected="multiSlotMode"
              @select="onSlotSelect"
              @remove="onSlotRemove"
              @input="onSlotInput"
              :max-height="150"
              :max="50"
            >
            </multiselect>
          </b-field>
        </div>
      </div>
      <slot name="extraFields"></slot>
      <div class="column is-3">
        <b-field label="Valor del servicio *">
          <b-input
            placeholder="Valor"
            type="text"
            v-model="service.total"
            readonly="readonly"
            icon="currency-usd"
          />
        </b-field>
      </div>
      <div class="column is-3">
        <b-field label="Periodicidad">
          <treeselect
            placeholder="Seleccione la periodicidad"
            expanded
            :options="periodicities"
            v-model="service.periodicity"
            name="typeUse"
          />
        </b-field>
        <span class="show-error">{{ errors.first('duration') }}</span>
      </div>

      <div class="column is-3" v-if="showMultiparking">
        <b-field label="Multiparqueadero">
          <vs-switch v-model="service.isMultiparking" />
        </b-field>
      </div>

      <div class="column is-3">
        <b-field label="Restricción placa" v-if="showPlateRestriction">
          <b-select
            placeholder="Seleccione una opción"
            expanded
            v-model="service.plateRestriction"
            name="plateRestriction"
          >
            <option
              value=""
              v-if="getValidArray(plateRestrictionList).length === 0"
            >
              No hay opciones para mostrar
            </option>

            <option
              v-for="prItem in getValidArray(plateRestrictionList)"
              :value="prItem"
              :key="prItem.id"
              :id="prItem.id"
            >
              {{ prItem.title }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-3" v-if="isPostpaid">
        <b-field label="Horas de parqueo Postpago">
          <b-input
            placeholder="Ingrese número de horas"
            type="number"
            v-model="postPaidHours"
          />
        </b-field>
      </div>
      <!-- CAMPO PARA SELECCIÓN MÚLTIPLE DE TARIFAS -->
      <div class="column is-3" v-if="isPostpaid">
        <b-field label="Tarifas liquidación postpago (múltiples)">
          <multiselect
            v-model="selectedTariffs"
            :options="tariffList"
            :multiple="true"
            :close-on-select="false"
            :show-no-results="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Seleccione una o más tarifas"
            label="title"
            track-by="code"
            :searchable="true"
            :loading="false"
            :internal-search="true"
            :hide-selected="false"
            :max-height="100"
            :max="2"
          >
          </multiselect>
        </b-field>
      </div>
      <div class="column flex-end">
        <b-button @click="addItem()" type="is-info">Agregar item</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import unityEndpoint from '@/endpoints/core/UnityEndpoint'
import kind from '@/global/lasting/EKind'
import liquidationEndpoint from '@/endpoints/billing/LiquidationEndpoint'
import liquidationType from '@/global/lasting/ELiquidationType'
import slotEndpoint from '@/endpoints/core/SlotEndpoint'
import scheduleEndpoint from '@/endpoints/income/ScheduleEndpoint'
import scheduleType from '@/global/lasting/EScheduleType'
import DateUtils from '@/global/DateUtils'
import toast from '@/global/ToastConfig'
import { isGreaterThan } from '@/global/utils'
import settingsEndPoint from '@/endpoints/core/SettingsEndpoint'
import { getValidArray as getValidArrayFn } from '@/helpers/arrays'
import tariffEndpoint from '@/endpoints/billing/TariffEndpoint'
import Multiselect from 'vue-multiselect'

export default {
  name: 'GeneralService',
  components: { Multiselect },
  props: {
    companyId: Number,
    service: Object,
    showMultiparking: {
      type: Boolean,
      default: false,
    },
    showPlateRestriction: {
      type: Boolean,
      default: false,
    },
    showMultiSlot: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      locale: "es",
      plateRestrictionList: [],
      incomeTypeList: [],
      liquidationList: [],
      slotList: [],
      scheduleList: [],
      isIndividual: false,
      quotaValue: this.service.quota,
      forceRender: 0,
      periodicities: [
        { label: 'Mensual', id: 'MONTHLY' },
        { label: 'Quincenal', id: 'BIWEEKLY' },
        { label: 'Días', id: 'DAILY' },
      ],
      isPostpaid: false,
      incomeType: null,
      postPaidHours: 0,
      tariffList: [],
      tariff: null,
      selectedTariffs: [], // Lista de tarifas seleccionadas

      // PROPIEDADES PARA MULTISELECT CON LÓGICA DUAL
      multiSlotMode: false,
      slotSelection: null, // Lo que ve el usuario en el multiselect
      isInitialized: false,
      multiselectKey: 0,
      pendingSlotData: null,
      isUpdatingSlot: false,
    }
  },
  computed: {
    // Label dinámico del campo
    slotFieldLabel() {
      return this.multiSlotMode ? 'Lotes*' : 'Lote*'
    },

    // Placeholder dinámico
    slotPlaceholder() {
      return this.multiSlotMode
        ? 'Seleccione uno o más lotes'
        : 'Seleccione un lote'
    },
  },
  created() {
    // Inicializar slotList si no existe
    if (!this.service.slotList) {
      this.$set(this.service, 'slotList', [])
    }

    // Guardar datos de slot inicial si existen antes de que se carguen las opciones
    this.pendingSlotData = {
      slot: this.service.slot,
      slotList: this.service.slotList || [],
    }
  },
  mounted() {
    this.incomeType = this.service.incomeType
    unityEndpoint
      .getUnityListByKind(kind.INCOME_TYPES, 'mensualidad')
      .then((info) => (this.incomeTypeList = info))

    this.launchQueries()

    const isPartial = this.service.isPartial
    this.isIndividual = isPartial && 'YES' === isPartial

    // CONFIGURACIÓN INICIAL CON LÓGICA DUAL
    this.initializeSlotConfiguration()
  },
  watch: {
    isIndividual() {
      this.service.isPartial = this.isIndividual ? 'YES' : 'NO'
      this.confirmIndividual()
    },
    quotaValue(newValue, oldValue) {
      if (newValue === '') {
        return
      }
      if (!isGreaterThan(newValue, 1)) {
        this.quotaValue = oldValue || 1
      }
      this.service.quota = this.quotaValue
    },
    incomeType() {
      this.service.incomeType = this.incomeType
      this.validatePostPaid()
    },
    postPaidHours() {
      this.service.postPaidHours = this.postPaidHours
    },
    tariff() {
      this.service.tariff = this.tariff
    },
    selectedTariffs() {
      // Guardar la lista de tarifas seleccionadas
      this.service.listTariff = this.selectedTariffs
    },

    // WATCHER PARA showMultiSlot CON LÓGICA DUAL
    showMultiSlot: {
      handler(newVal, oldVal) {
        // Solo procesar si el componente está inicializado y el valor es diferente
        if (!this.isInitialized || newVal === this.multiSlotMode) {
          return;
        }

        // Aplicar el cambio de modo directamente
        this.applyDynamicModeChange(!!newVal);
      },
      immediate: true, // Ejecutar inmediatamente para sincronizar estado inicial
    },

    // Watcher para detectar cambios externos en service.slot
    'service.slot': {
      handler(newVal, oldVal) {
        if (!this.isInitialized || this.isUpdatingSlot) {
          return
        }
        this.handleExternalSlotChange(newVal)
      },
      deep: true,
    },

    // NUEVO: Watcher para detectar cambios en service.slotList
    'service.slotList': {
      handler(newVal, oldVal) {
        if (!this.isInitialized || this.isUpdatingSlot) {
          return
        }
        this.handleExternalSlotListChange(newVal)
      },
      deep: true,
    },
  },
  methods: {
    getValidArray(array) {
      return getValidArrayFn(array)
    },

    launchQueries() {
      settingsEndPoint
        .getRestrictedDrivingOptions({ companyCode: this.companyId })
        .then(({ info }) => {
          this.plateRestrictionList = info
        })

      liquidationEndpoint
        .listByLiquidationType(
          liquidationType.LIQUIDATION_MONTHLY,
          this.companyId
        )
        .then((info) => {
          this.liquidationList = info
          const initial = this.service.liquidation
          if (initial) {
            this.service.liquidation = this.liquidationList.find(
              (item) => item.code === initial.code
            )
          }
        })

      slotEndpoint.listByCompany(this.companyId).then((info) => {
        this.slotList = info
        // Procesar datos pendientes después de cargar opciones
        this.processPendingSlotData()
      })

      scheduleEndpoint
        .findByTypeAndCompany(scheduleType.SCHEDULE_MONTHLY, this.companyId)
        .then((info) => {
          this.scheduleList = info
          const initial = this.service.schedule
          if (initial) {
            this.service.schedule = this.scheduleList.find(
              (item) => item.code === initial.code
            )
          }
        })
        tariffEndpoint.tariffList(this.companyId).then((info) => {
                this.tariffList = info
                if (this.service.tariff) {
                  this.tariff = this.tariffList.find(
                    (item) => item.code === this.service.tariff.code
                  )
                }
                // Inicializar la lista de tarifas si existe
                if (this.service.listTariff && Array.isArray(this.service.listTariff)) {
                  this.selectedTariffs = this.service.listTariff.map(tariff => 
                    this.tariffList.find(item => item.code === tariff.code) || tariff
                  )
                }
              })
    },

    confirmIndividual() {
      if (this.isIndividual) return
      const itemList = this.service.itemList
      if (itemList.length <= 0) return
      toast
        .ask(
          this,
          '¿Está seguro? se van a actualizar todos los items con la fecha final del servicio'
        )
        .then((result) => {
          if (!result) {
            this.isIndividual = true
            return
          }
          itemList.forEach((item) => (item.finalDate = this.service.finalDate))
        })
    },

    validateQuota() {
      if (!this.service.quota || this.quotaValue < 1) {
        toast.error('Cantidad de cupos es mayor o igual 1')
        this.quotaValue = 1
      }
      this.service.quota = this.quotaValue
    },

    addItem() {
      this.$emit('addItem')
    },

    formatDate(a) {
      return DateUtils.toDateShortString({ date: a, timezone: '' })
    },

    validatePostPaid() {
      this.isPostpaid = false
      if (!this.incomeType) {
        this.isPostpaid = false
        return
      }
      if (this.incomeType.initials === 'POST') {
        this.isPostpaid = true
      }
    },

    // Configuración inicial con lógica dual
    initializeSlotConfiguration() {
      this.multiSlotMode = !!this.showMultiSlot

      // Inicializar selección según el modo
      if (this.multiSlotMode) {
        this.initializeMultiSlot()
        this.isInitialized = true
        return
      }

      this.initializeSingleSlot()
      this.isInitialized = true
    },

    initializeMultiSlot() {
      // Usar directamente la lista de slots o inicializar como array vacío
      this.slotSelection = Array.isArray(this.service.slotList) && this.service.slotList.length > 0
        ? [...this.service.slotList]
        : []

      // Asegurar que service.slot sea el primer elemento de slotList
      this.ensureSlotFromSlotList()
    },

    initializeSingleSlot() {
      // Inicializar selección con el slot actual y limpiar slotList
      this.slotSelection = this.service.slot || null
      this.service.slotList = []
    },

    handleMultiSlotMode(slotList, slot) {
      // Procesar slotList si existe y tiene elementos
      if (this.processSlotListForMultiMode(slotList)) {
        return;
      }

      // Procesar slot individual si existe
      this.processSlotForMultiMode(slot);
    },

    // Procesar lista de slots para modo múltiple
    processSlotListForMultiMode(slotList) {
      if (!slotList || slotList.length === 0) {
        return false;
      }

      this.slotSelection = slotList
        .map(
          (slotItem) =>
            this.slotList.find((item) => item.code === slotItem.code) ||
            slotItem
        )
        .filter(Boolean);
      this.service.slotList = [...this.slotSelection];
      this.ensureSlotFromSlotList();
      this.pendingSlotData = null;
      this.forceMultiselectRerender();
      return true;
    },

    // Procesar slot individual para modo múltiple
    processSlotForMultiMode(slot) {
      // Si no hay slot, limpiar datos pendientes
      if (!slot) {
        this.pendingSlotData = null;
        this.forceMultiselectRerender();
        return;
      }

      // Buscar slot en la lista disponible
      const foundSlot = this.slotList.find((item) => item.code === slot.code);
      if (foundSlot) {
        this.slotSelection = [foundSlot];
        this.service.slotList = [foundSlot];
        this.service.slot = foundSlot;
      }

      this.pendingSlotData = null;
      this.forceMultiselectRerender();
    },

    // Procesar datos pendientes después de cargar opciones
    processPendingSlotData() {
      if (!this.pendingSlotData) {
        return
      }

      const { slot, slotList } = this.pendingSlotData

      if (this.multiSlotMode) {
        this.handleMultiSlotMode(slotList, slot)
        return
      }

      this.processSimpleModeData(slot)
    },

    // Procesar datos en modo simple
    processSimpleModeData(slot) {
      if (!slot) {
        this.resetSlotData()
        return
      }

      const foundSlot = this.slotList.find(item => item.code === slot.code)
      if (foundSlot) {
        this.slotSelection = foundSlot
        this.service.slot = foundSlot
      }

      this.resetSlotData()
    },

    resetSlotData() {
      this.service.slotList = []
      this.pendingSlotData = null
      this.forceMultiselectRerender()
    },

    // Aplicar cambio de modo dinámico
    applyDynamicModeChange(newMode) {
      const previousMode = this.multiSlotMode;
      this.multiSlotMode = newMode;

      // Aplicar cambios según el nuevo modo
      newMode ? this.switchToMultipleMode() : this.switchToSimpleMode();

      // Forzar re-render y emitir evento
      this.forceMultiselectRerender();
      this.emitSlotModeChanged(newMode, previousMode);
    },

    // Cambiar a modo múltiple
    switchToMultipleMode() {
      // Convertir slot actual a lista
      this.slotSelection = this.service.slot ? [this.service.slot] : [];
      this.service.slotList = this.service.slot ? [this.service.slot] : [];
    },

    // Cambiar a modo simple
    switchToSimpleMode() {
      // Tomar el primer elemento de la lista como slot principal
      const hasValidSlotList = this.service.slotList && this.service.slotList.length > 0;
      const firstSlot = hasValidSlotList ? this.service.slotList[0] : null;

      this.slotSelection = firstSlot;
      this.service.slot = firstSlot;
      this.service.slotList = [];
    },

    // Emitir evento de cambio de modo
    emitSlotModeChanged(newMode, previousMode) {
      this.$emit('slot-mode-changed', {
        isMultiple: newMode,
        previousMode: previousMode,
        selection: this.slotSelection,
        service: {
          slot: this.service.slot,
          slotList: this.service.slotList,
        },
      });
    },

    // Manejar cambios externos en service.slot
    handleExternalSlotChange(newSlotValue) {
      // En modo simple, actualizar slotSelection directamente
      // En modo múltiple, slot se maneja via slotList
      this.slotSelection = this.multiSlotMode ? this.slotSelection : newSlotValue;
    },

    // NUEVO: Manejar cambios externos en service.slotList
    handleExternalSlotListChange(newSlotListValue) {
      // Solo procesar en modo múltiple y si es un array válido
      if (!this.multiSlotMode || !Array.isArray(newSlotListValue)) {
        return;
      }

      this.slotSelection = [...newSlotListValue];
      this.ensureSlotFromSlotList();
    },

    // Forzar re-render del componente multiselect
    forceMultiselectRerender() {
      this.multiselectKey++
    },

    // Manejar selección de slot
    onSlotSelect(selectedOption) {
      this.updateServiceSlot()
      this.$emit('slot-selected', {
        slot: selectedOption,
        isMultiple: this.multiSlotMode,
        allSelected: this.slotSelection,
        service: {
          slot: this.service.slot,
          slotList: this.service.slotList,
        },
      })
    },

    // Manejar remoción de slot
    onSlotRemove(removedOption) {
      this.updateServiceSlot()
      this.$emit('slot-removed', {
        slot: removedOption,
        isMultiple: this.multiSlotMode,
        allSelected: this.slotSelection,
        service: {
          slot: this.service.slot,
          slotList: this.service.slotList,
        },
      })
    },

    // Manejar cambios en la selección
    onSlotInput(value) {
      this.slotSelection = value
      this.updateServiceSlot()
    },

    // CLAVE: Actualizar service con lógica dual
    updateServiceSlot() {
      this.isUpdatingSlot = true

      // Actualizar según el modo (múltiple o simple)
      this.multiSlotMode
        ? this.updateMultiModeSlots()
        : this.updateSimpleModeSlot();

      // Finalizar actualización en el siguiente ciclo
      this.finishSlotUpdate();
    },

    // Actualizar slots en modo múltiple
    updateMultiModeSlots() {
      // Convertir selección a array y actualizar slotList
      this.service.slotList = Array.isArray(this.slotSelection)
        ? [...this.slotSelection]
        : [];

      // Asegurar que slot sea el primer elemento
      this.ensureSlotFromSlotList();

      // Emitir evento de actualización
      this.emitSlotsUpdated();
    },

    // Actualizar slot en modo simple
    updateSimpleModeSlot() {
      // Actualizar slot y limpiar slotList
      this.service.slot = this.slotSelection;
      this.service.slotList = [];

      // Emitir evento de actualización
      this.emitSlotsUpdated();
    },

    // Emitir evento de actualización de slots
    emitSlotsUpdated() {
      this.$emit('slots-updated', {
        slot: this.service.slot,
        slotList: this.service.slotList,
        isMultiple: this.multiSlotMode,
      });
    },

    // Finalizar actualización en el siguiente ciclo
    finishSlotUpdate() {
      this.$nextTick(() => {
        this.isUpdatingSlot = false;
      });
    },

    // NUEVO: Asegurar que service.slot sea el primer elemento de slotList
    ensureSlotFromSlotList() {
      this.service.slot =
        this.service.slotList && this.service.slotList.length > 0
          ? this.service.slotList[0]
          : null
    },

    // MÉTODOS UTILITARIOS PÚBLICOS

    // Obtener códigos de slots seleccionados
    getSelectedSlotCodes() {
      return this.multiSlotMode
        ? this.getMultiModeSlotCodes()
        : this.getSingleModeSlotCodes();
    },

    // Obtener códigos de slots en modo múltiple
    getMultiModeSlotCodes() {
      if (!Array.isArray(this.service.slotList)) {
        return [];
      }

      return this.service.slotList.map(slot => slot.code);
    },

    // Obtener códigos de slots en modo simple
    getSingleModeSlotCodes() {
      return this.service.slot ? [this.service.slot.code] : [];
    },

    // Limpiar selección
    clearSlotSelection() {
      this.slotSelection = this.multiSlotMode ? [] : null
      this.service.slot = null
      this.service.slotList = []
    },

    // Validar si hay selección
    hasSlotSelection() {
      return this.multiSlotMode
        ? this.hasMultiModeSelection()
        : this.hasSingleModeSelection();
    },

    // Validar si hay selección en modo múltiple
    hasMultiModeSelection() {
      return Array.isArray(this.service.slotList) && this.service.slotList.length > 0;
    },

    // Validar si hay selección en modo simple
    hasSingleModeSelection() {
      return this.service.slot !== null && this.service.slot !== undefined;
    },

    // NUEVO: Obtener el slot principal (siempre será service.slot)
    getPrimarySlot() {
      return this.service.slot
    },

    // NUEVO: Obtener todos los slots (en modo múltiple slotList, en simple [slot])
    getAllSlots() {
      return this.multiSlotMode
        ? this.getMultiModeSlots()
        : this.getSingleModeSlots();
    },

    // Obtener slots en modo múltiple
    getMultiModeSlots() {
      return this.service.slotList || [];
    },

    // Obtener slots en modo simple
    getSingleModeSlots() {
      return this.service.slot ? [this.service.slot] : [];
    },

    // NUEVO: Programáticamente cambiar a modo múltiple
    enableMultiSlotMode() {
      // Solo aplicar cambio si no está ya en modo múltiple
      !this.multiSlotMode && this.applyDynamicModeChange(true);
    },

    // NUEVO: Programáticamente cambiar a modo simple
    enableSingleSlotMode() {
      // Solo aplicar cambio si no está ya en modo simple
      this.multiSlotMode && this.applyDynamicModeChange(false);
    },
  },
}
</script>

<style scoped>
.columns {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
}

.column {
  width: 100%;
  display: flex;
}

.column .field {
  width: 100%;
}

.column.flex-end {
  align-items: flex-end;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
